import React from "react";
import "./TechStackSection.css";

import { FaReact, FaNodeJs, FaAws, FaFigma } from "react-icons/fa";
import {
  SiMongodb,
  SiKubernetes,
  SiAndroid,
  SiPython,
} from "react-icons/si";



const techData = [
  {
    title: "Frontend Development",
    items: "React.js, Next.js, TypeScript, JavaScript",
    icon: <FaReact color="#61DAFB" size={28} />,
  },
  {
    title: "Backend Development",
    items: "Node.js, Express.js, Python, REST APIs",
    icon: <FaNodeJs color="#68A063" size={28} />,
  },
  {
    title: "Database Training",
    items: "MongoDB, PostgreSQL, MySQL, Redis",
    icon: <SiMongodb color="#47A248" size={28} />,
  },
  {
    title: "Mobile App Development",
    items: "Android, React Native, Flutter",
    icon: <SiAndroid color="#3DDC84" size={28} />,
  },
  {
    title: "Cloud & DevOps",
    items: "AWS, Azure, Docker, Kubernetes",
    icon: <FaAws color="#FF9900" size={28} />,
  },
  {
    title: "AI & Machine Learning",
    items: "Python, AI, ML, Data Science",
    icon: <SiPython color="#3776AB" size={28} />,
  },
  {
    title: "UI/UX Design",
    items: "Figma, Canva, Adobe XD",
    icon: <FaFigma color="#F24E1E" size={28} />,
  },
  {
    title: "Industrial Automation",
    items: "PLC, SCADA, Robotics, Automation Systems",
    icon: <SiKubernetes color="#326CE5" size={28} />,
  },
];

const TechStackSection = () => {
  return (
    <section
      className="tech-section"
      style={{
        // backgroundImage: `url(${bgImage})`,
      }}
    >
      <div className="tech-container">
        {/* Header */}
        <div className="tech-header">
          <h2>
            Technologies <span style={{ color: "white" }}>We Teach</span>
          </h2>

          <p>
            Internal Institute of Automation provides industry-focused
            training programs 
          </p>
        </div>

        {/* Technology Grid */}
        <div className="tech-grid">
          {techData.map((tech, index) => (
            <div className="tech-card" key={index}>
              <div className="tech-icon">{tech.icon}</div>

              <h3>{tech.title}</h3>

              <p>{tech.items}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechStackSection;